import Vue from 'vue';
import {
  Select,
  Option,
  Switch,
  Loading,
  Breadcrumb,
  BreadcrumbItem,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Empty,
} from 'element-ui';

Vue.use(Select)
  .use(Option)
  .use(Switch)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Loading)
  .use(Dropdown)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Empty);
